import { showArticle } from '@intercom/messenger-js-sdk'

import { intercomHelpCenterId } from '@/libs/constants/intercom-article'
import { useAppDispatch } from '@/libs/hooks/use-app-dispatch'
import { toggleIntercom } from '@/libs/store/slice/ui-slice'

type TSurveyRemarksButton = {
  show?: boolean
  text?: string
}

export default function SurveyRemarksButton({ show, text }: Readonly<TSurveyRemarksButton>) {
  const dispatch = useAppDispatch()

  const showIntercomArticle = () => {
    dispatch(toggleIntercom(true))
    return showArticle(intercomHelpCenterId)
  }

  if (!show && !text) {
    return null
  }

  return (
    <button
      type='button'
      onClick={showIntercomArticle}
      className='text-center text-sm font-normal text-pop-blue-400 underline'
    >
      {text}
    </button>
  )
}
